import type { Ref } from 'vue'

export interface CookieOptions<T = string> {
  default?: () => T | Ref<T>
  encode?: (value: T) => string
  decode?: (value: string) => T
  expires?: Date
  maxAge?: number
  domain?: string
  path?: string
  secure?: boolean
  httpOnly?: boolean
  sameSite?: 'strict' | 'lax' | 'none'
  watch?: boolean | 'shallow'
}

export interface AdvCookieOptions<T> extends CookieOptions<T> {
  forceRefresh?: boolean
}

export interface CookieRef<T> extends Ref<T> {
  value: T
}

// 全局event
export const EVENT_SIGN_IN = 'signIn' // 登录
export const EVENT_SIGN_OUT = 'signOut' // 退出
export const EVENT_UPDATE_USER_MESSAGE = 'updateUser_for_message' // 更新用户信息